import React, { HTMLProps } from "react";
import { useTranslation } from "react-i18next";
import {
    NibudPensionResponeType,
    useGetNibudHomeOptions,
    useGetNibudHomeType,
    useGetNibudHomeWOZOptions
} from "../../../api/nibud/useGetNibudOptions";
import { DISABLED_OPTION_PLACHOLDER_ID } from "../../../config/constants";
import { NibudHouseCategory, NibudHouseType } from "../../../contexts/pension-robot/PensionContext";
import { reverseFormatNumber } from "../../../utils/parsers";
import { someAreError, someAreFetching, someAreIdle, someAreLoading } from "../../../utils/queries";
import { LoadingStateWrapper } from "../../general/LoadingStateWrapper";
import { NibudField } from "./NibudModalFields";


export const nibudResponseToOptions = (response: NibudPensionResponeType[] | undefined) => {
    if (response === undefined){
        return [{
            label: "Loading options...",
            value: "Loading options...",
        }]
    }
    return response.map( (genderOption) => {
        return { 
            label: genderOption.name,
            value: genderOption.value
        }
    });
}

export const NibudModalStepHousing: React.FC<HTMLProps<HTMLDivElement>> = () => {
    const { t } = useTranslation('pension');
    const nibudHomeOptions = useGetNibudHomeOptions();
    const nibudHomeWOZOptions = useGetNibudHomeWOZOptions();
    const nibudHomeTypeOptions = useGetNibudHomeType();

    const optionsToLoad = [nibudHomeOptions, nibudHomeWOZOptions, nibudHomeTypeOptions]

    return (
        <LoadingStateWrapper 
            isLoading={someAreLoading(optionsToLoad)}
            isFetching={someAreFetching(optionsToLoad)}
            isError={someAreError(optionsToLoad)}
            isIdle={someAreIdle(optionsToLoad)}
            >
                <NibudField info={
                    {
                        title: t('pension-nibud-house-payment-category'),
                        type: 'select',
                        select: {
                            options: nibudResponseToOptions(nibudHomeOptions.data),
                        },
                        get: (params) => params?.nibud?.house?.paymentCategory ? "" + params?.nibud?.house?.paymentCategory : DISABLED_OPTION_PLACHOLDER_ID,
                        onChange: (value) => {
                            return { expensesInfo: { nibud: { house: { paymentCategory: value as NibudHouseCategory } } } };
                        },
                    }
                }/>
                <NibudField info={
                    {
                        title: t('pension-nibud-house-type'),
                        type: 'select',
                        select: {
                            options: nibudResponseToOptions(nibudHomeTypeOptions.data),
                        },
                        get: (params) => params?.nibud?.house?.houseType ? '' + params?.nibud?.house?.houseType : DISABLED_OPTION_PLACHOLDER_ID,
                        onChange: (value) => {
                            return { expensesInfo: { nibud: { house: { houseType: value as NibudHouseType } } } };
                        },
                    }
                }/>
                <NibudField info={
                    {
                        title: t('pension-nibud-house-rent'),
                        type: 'money',
                        placeholder: '€',
                        tooltip: { title: 'TODO', text: 'TODO' },
                        show: (params) => params?.nibud?.house?.paymentCategory === 'Huurwoning',
                        get: (params) => '' + (params?.nibud?.house?.rent ?? 0) / 100,
                        onChange: (value) => {
                            return { expensesInfo: { nibud: { house: { rent: toDecimal(value) } } } };
                        },
                    }
                }/>
                <NibudField info={
                    {
                        title: t('pension-nibud-house-buy-mortgage'),
                        type: 'money',
                        placeholder: '€',
                        tooltip: { title: 'TODO', text: 'TODO' },
                        show: (params) => params?.nibud?.house?.paymentCategory === 'Koopwoning',
                        get: (params) => '' + (params?.nibud?.house?.mortgage ?? 0) / 100,
                        onChange: (value) => {
                            return { expensesInfo: { nibud: { house: { mortgage: toDecimal(value) } } } };
                        },
                    }
                }/>
                <NibudField info={
                    {
                        title: t('pension-nibud-house-woz'),
                        type: 'select',
                        select: {
                            options: nibudResponseToOptions(nibudHomeWOZOptions.data),
                        },
                        tooltip: { title: 'TODO', text: 'TODO' },
                        show: (params) => params?.nibud?.house?.paymentCategory === 'Koopwoning',
                        get: (params) => params?.nibud?.house?.woz ? '' + params?.nibud?.house?.woz : DISABLED_OPTION_PLACHOLDER_ID,
                        onChange: (value) => {
                            return { expensesInfo: { nibud: { house: { woz: value } } } };
                        },
                    }
                }/>
        </LoadingStateWrapper>
    );
};

export function toDecimal(value: string): number {
    const decimal = reverseFormatNumber(value, 'nl-NL');
    return Math.ceil(+decimal * 100);
};